import { graphql } from '@/generated/gql';

export const INTAKE_QUOTE_SUPPLIER_CONFIRMATION = graphql(/* GraphQL */ `
  query IntakeQuoteSupplierConfirmation($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        variant
        suppliers {
          id
          internalId
          contact {
            internalId
            email
            firstName
            language
            lastName
            mobile
            phone
            title
          }
          location {
            internalId
            address
            city
            postalCode
            countryCode
          }
          isQuoted
        }
      }
    }
  }
`);
